import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { fallbackRefetchInterval } from '@/lib/realtime';
import { useSocketStore } from '@/stores/socketStore';
import type { InterventionDetail } from './useSocket';

export function useIntervention(id: string | null) {
  const connected = useSocketStore((s) => s.connected);
  return useQuery({
    queryKey: ['interventions', 'detail', id],
    queryFn: () => api.get<{ intervention: InterventionDetail }>(`/interventions/${id}`),
    select: (d) => d.intervention,
    enabled: !!id,
    staleTime: 10_000,
    // Filet de sécurité UNIQUEMENT si le socket tombe : tant que le drawer est
    // ouvert (id non null) et le socket déconnecté, on rafraîchit le détail pour
    // ne pas afficher une fiche figée. Connecté → invalidation socket en direct.
    refetchInterval: id ? fallbackRefetchInterval(connected, 30_000) : false,
    refetchOnWindowFocus: true,
  });
}
